export default {
  model: null,
  nowOptions: [],
  userId: '',
  id: '',
  now: '',
  memo: ''
}
